import { render, staticRenderFns } from "./BackerCenterPledgesSection.vue?vue&type=template&id=291f0cf6"
import script from "./BackerCenterPledgesSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports